import { render, staticRenderFns } from "./CustomElementPagination.vue?vue&type=template&id=4e41c005&scoped=true&"
import script from "./CustomElementPagination.vue?vue&type=script&lang=js&"
export * from "./CustomElementPagination.vue?vue&type=script&lang=js&"
import style0 from "./CustomElementPagination.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./CustomElementPagination.vue?vue&type=style&index=1&id=4e41c005&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e41c005",
  null
  
)

export default component.exports